import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faLink, faPlus } from '@fortawesome/pro-regular-svg-icons';
import cn from 'classnames';
import _ from 'lodash';
import './ShopPageHeaderEditSocialLinks.scss';

import { getSocialIconForUrl } from '../../../Helpers/social_helpers';

const ShopPageHeaderEditSocialLinks = props => {
  const { social_links } = props;

  const [links, setLinks] = React.useState((social_links?.split(',') || []).filter(l => l.replaceAll(' ', '').length > 0));
  const [curNewLink, setCurNewLink] = React.useState('');
  const newLinkIcon = getSocialIconForUrl(curNewLink, 'dark');

  const removeLink = link => {
    setLinks(links.filter(l => l !== link));
    props.setUpdatedSocialLinks(links.filter(l => l !== link).join(','));
  };

  const canAddLink = curNewLink.length && curNewLink.includes('.') && !links.includes(curNewLink);
  const addNewLink = () => {
    if (!curNewLink) return window.ALERT.error('Please enter a link');
    setLinks(_.uniq([...links, curNewLink]));
    props.setUpdatedSocialLinks(_.uniq([...links, curNewLink]).join(','));
    setCurNewLink('');
  };

  return (
    <div className='shop-page-header-edit-social-links'>
      {links.map(link => {
        const icon = getSocialIconForUrl(link, 'dark');
        return (
          <div className='social-link' key={link}>
            <div className='icon'>{icon ? <img src={icon} alt={link} /> : <FontAwesomeIcon icon={faLink} />}</div>
            <div className='link'>{link}</div>
            <div className='actions'>
              <div onClick={() => removeLink(link)} className='action remove'>
                <FontAwesomeIcon icon={faTimes} />
              </div>
            </div>
          </div>
        );
      })}
      <div className='social-link add'>
        <div className='icon'>{newLinkIcon ? <img src={newLinkIcon} alt={curNewLink} /> : <FontAwesomeIcon icon={faLink} />}</div>
        <form
          onSubmit={e => {
            e.preventDefault();
            addNewLink();
          }}
        >
          <input type='text' placeholder='Add a link' value={curNewLink} onChange={e => setCurNewLink(e.target.value)} />
        </form>
        <div className='actions'>
          <div
            onClick={() => {
              if (canAddLink) addNewLink();
            }}
            className={cn('action add', { disabled: !canAddLink, primary: canAddLink })}
          >
            <FontAwesomeIcon icon={faPlus} />
          </div>
        </div>
      </div>
    </div>
  );
};

ShopPageHeaderEditSocialLinks.propTypes = {
  social_links: PropTypes.string.isRequired,
  setUpdatedSocialLinks: PropTypes.func.isRequired
};

export default ShopPageHeaderEditSocialLinks;
